import React, { useContext } from 'react'
import { Button, LabelTooltip, ResponsiveTableRow } from '@fs/zion-ui'
import { PlaceCemetary } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { PersonLink, UserLink } from '../../app/Links'
import { PermissionsContext } from '../../app/PermissionsContext'

// MJV remove merge.operation when merge.op has been deployed
export default function MergeRow({ merge, isUndoDisabled, handleOpen }) {
  const { t } = useTranslation()
  const { isAuthorized } = useContext(PermissionsContext)

  const label = merge.duplicatePersonOwnerInfo?.contributorId?.value
    ? `${t('contributor', 'Contributor')}: ${merge.duplicatePersonOwnerInfo?.header} (${
        merge.duplicatePersonOwnerInfo?.contributorId?.value?.value
      })`
    : t('person.merges.errors.gettingContributor', 'Error getting contributor')

  const floatRight = css`
    float: right;
  `

  return (
    <ResponsiveTableRow
      name={merge.changeId}
      column1={merge.op ? t(`person.changes.${merge.op}`, merge.op) : merge.operation}
      column2={merge.reason}
      column3={merge.date}
      column4={<PersonLink personId={merge.survivorPersonId} personName={merge.survivorPersonName} showId />}
      column5={
        <>
          {merge.duplicatePersonTombstoned && <PlaceCemetary size="xs" />}
          <LabelTooltip
            label={label}
            target={
              <span aria-label={label}>
                <PersonLink
                  personId={merge.duplicatePersonId}
                  personName={merge.duplicatePersonName}
                  showId
                  forward={false}
                  newTab
                />
              </span>
            }
          />
        </>
      }
      column6={<UserLink userId={merge.submitterId} userName={merge.submitterName} />}
      column7={
        <span css={floatRight}>
          <Button
            id="undoMergeBtn"
            emphasis="high"
            disabled={
              merge.operation !== 'Merged' ||
              !isAuthorized([
                'FtWritePermission',
                'ViewAllPrivateSpaceEntitiesPermission',
                'ModifyLockedCtEntitiesPermission',
                'ModifyAllPrivateSpaceEntitiesPermission',
              ]) ||
              isUndoDisabled(merge)
            }
            onClick={() => handleOpen(merge.changeId)}
          >
            {t('person.merges.undoMerge', 'Undo Merge')}
          </Button>
        </span>
      }
    />
  )
}
